var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptedIntoCollege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 120,
    viewBox: "0 0 146 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M5.66415 67.1563C11.6395 58.147 38.4905 70.0174 61.5399 62.1152C81.5027 55.2691 72.7697 40.7406 89.9037 38.8272C102.421 37.4273 117.814 41.1684 128.523 49.9806C140.332 59.6964 141.044 71.1989 141.104 74.0062C141.389 86.5956 132.438 94.533 129.256 97.2617C116.146 108.499 97.5716 109.503 88.6616 109.988C55.19 111.801 14.2404 98.3783 6.03551 78.6118C4.95827 76.0245 2.9674 71.2245 5.66415 67.1563Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3187 47.6859L57.2271 51.5296V63.6088H78.7729V51.5338L81.701 50.5036V56.1213H80.5073V63.6098H84.4583V56.1213H83.2625V49.9536L89.6823 47.6932L68 39.1807L46.3187 47.6859ZM77.2093 62.0463H58.7885V52.0807L67.9989 55.3265L77.2093 52.0859V62.0463ZM82.8958 62.0463H82.0677V57.6827H82.8958V62.0463ZM82.4062 48.5973L69.5354 46.5671C69.2698 45.9807 68.6833 45.5713 67.9989 45.5713C67.0687 45.5713 66.3125 46.3286 66.3125 47.2588C66.3125 48.189 67.0698 48.9463 67.9989 48.9463C68.6083 48.9463 69.1385 48.6192 69.4354 48.1338L79.3052 49.69L67.9989 53.6702L57.226 49.8723L50.7958 47.6057L67.9989 40.8567L85.2041 47.6109L82.4062 48.5973Z",
    fill: "#171725"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.434 26.0149L92.3271 11.8264L87.1792 5.24928L86.9448 4.94824H32.5657V95.0524H103.433V26.0149H103.434ZM87.3448 7.99512L91.3053 13.0535L101.049 25.5024H87.3448V7.99512ZM101.872 93.4899H34.1282V6.51074H85.7823V27.0649H101.871V93.4899H101.872Z",
    fill: "#171725"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5635 67.9658H56.2031V69.5283H86.5635V67.9658Z",
    fill: "#171725"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8823 67.9658H48.5573V69.5283H52.8823V67.9658Z",
    fill: "#171725"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 78.5814,
    y1: 35.3912,
    x2: 67.2843,
    y2: 109.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FFC46B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedIntoCollege);
export default __webpack_public_path__ + "static/media/acceptedIntoCollege.c2eccec2e9bd8b538ff8aee13ee4e6ef.svg";
export { ForwardRef as ReactComponent };